// Darstellungsregeln der Selbstauskunft-Seite (design_handoff_selbstauskunft) — Farben, Zähler,
// aktiver Zeitraum-Knopf, Spaltenschwelle, Texte. Rein, ohne React/DB; status.ts/zeitraum.ts bleiben unverändert.
import { STATUS_REIHENFOLGE, type SelbstauskunftStatus } from './status';
import { erkennePreset, type ZeitraumPreset } from './zeitraum';

/** Statusfarben (Handoff §2.1) — dieselbe Bedeutung wie STATUS_BADGE in status.ts:
 *  Neu blau, Geprüft gelb, Eingeladen violett, Angenommen grün, Abgelehnt rot. */
export const STATUS_FARBE: Record<SelbstauskunftStatus, string> = {
  neu: '#2f7cf6',
  geprueft: '#e0a100',
  eingeladen: '#8a5cf5',
  angenommen: '#24a35a',
  abgelehnt: '#e5484d',
};

export type StatusOderAlle = SelbstauskunftStatus | 'alle';

/** Zähler je Status über die Objekt/Zeitraum-Auswahl (Status-Widgets = Filter UND Zähler). */
export function zaehleJeStatus(liste: readonly { status: SelbstauskunftStatus }[]): Record<StatusOderAlle, number> {
  const z = { alle: liste.length } as Record<StatusOderAlle, number>;
  for (const s of STATUS_REIHENFOLGE) z[s] = 0;
  for (const e of liste) if (e.status in z) z[e.status] += 1;
  return z;
}

/** Aktiver Knopf im Zeitraum-Segment: „Zeitraum“ bleibt aktiv, solange die Datumsfelder offen sind,
 *  auch wenn Von/Bis zufällig einem Preset entsprechen oder noch leer sind. */
export function aktiverZeitraum(von: string, bis: string, eigenerZeitraum: boolean, heuteIso: string): ZeitraumPreset {
  const p = erkennePreset(von, bis, heuteIso);
  return eigenerZeitraum || p === 'eigen' ? 'eigen' : p;
}

/** Ab dieser Breite stehen Liste und Eingang nebeneinander (Handoff §2). */
export const ZWEISPALTEN_AB = 1024;
export const istZweispaltig = (breite: number): boolean => breite >= ZWEISPALTEN_AB;

/** „1 Person“ / „n Personen“ (Haushalt = Antragsteller + Mitziehende). */
export const personenText = (n: number): string => `${n} ${n === 1 ? 'Person' : 'Personen'}`;

/** Initialen für den Avatar: erstes und letztes Wort, Großbuchstaben; leer → „?“. */
export function initialen(name: string): string {
  const teile = name.trim().split(/\s+/).filter(Boolean);
  if (teile.length === 0) return '?';
  const erst = teile[0]!.charAt(0);
  const letzt = teile.length > 1 ? teile[teile.length - 1]!.charAt(0) : teile[0]!.charAt(1);
  return `${erst}${letzt}`.toUpperCase();
}
